export const GET_LIST_REQUEST = "Comments/GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "Comments/GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "Comments/GET_LIST_FAILURE";

export const ADD_REQUEST      = "Comments/ADD_REQUEST";
export const ADD_SUCCESS      = "Comments/ADD_SUCCESS";
export const ADD_FAILURE      = "Comments/ADD_FAILURE";